import {H3Text, H5Text} from '@buncha/components/core/text';
import React, {useCallback} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {CenterBox} from '@buncha/components/core/view';
import {CommonScreens} from '@buncha/common/navigation/types';
import {CustomDialogBox} from '@buncha/components/composites/dialogBox';
import If from '@buncha/components/conditional/If';
import {MainScreens} from '@buncha/navigation/types';
import {Modules} from '@buncha/utils/types';
import {PButton} from '@buncha/components/core/Button';
import {ShopperScreens} from '@buncha/home/navigation/types';
import {StyleSheet} from 'react-native';
import {UserTypes} from '@buncha/onBoarding/types';
import {navigation} from '@buncha/config/navigation';
import {useGetLocale} from '@buncha/localization/hooks';

interface Props {
  runId: number;
  count: number;
  onClose: () => void;
}

const UnreadChatModal = (props: Props) => {
  const mortise = useFontTheme('mortise');
  const muli = useFontTheme('muli');
  const theme = useColorThemeType();
  const {title, body, button} =
    useGetLocale(Modules.batchDetails, ShopperScreens.BatchDetailsPage) ?? {};

  const {count} = props;

  const closeModal = useCallback(() => {
    props.onClose();
  }, [props]);

  const navigateToChat = useCallback(() => {
    closeModal();
    if (!props.runId) return;
    navigation.navigate(MainScreens.Common, {
      screen: CommonScreens.ConversationList,
      params: {runId: props.runId, hideRole: UserTypes.driver},
    });
  }, [closeModal, props.runId]);

  return (
    <If condition={Boolean(count)}>
      <CustomDialogBox
        modalBoxStyle={styles.modalBoxStyle}
        onClose={closeModal}
        header={
          <H3Text
            style={[
              styles.marBot10,
              {
                fontFamily: mortise[700].normal,
                color: theme?.text.blue[300],
              },
            ]}>
            {title?.unreadMessages?.replace('{count}', count)}
          </H3Text>
        }
        body={
          <CenterBox>
            <H5Text style={[{fontFamily: muli[700].normal}]}>
              {body?.haveUnreadMessages?.replace('{count}', count)}
            </H5Text>
            <H5Text style={[{fontFamily: muli[700].normal}]}>
              {body?.readMessages}
            </H5Text>
          </CenterBox>
        }
        footer={
          <PButton
            title={button?.readMessages}
            style={styles.actionButton}
            titleStyle={{
              fontFamily: muli[700].normal,
            }}
            onPress={navigateToChat}
          />
        }
      />
    </If>
  );
};

export default React.memo(UnreadChatModal);

export const styles = StyleSheet.create({
  actionButton: {
    borderRadius: 50,
    marginBottom: 10,
  },
  modalBoxStyle: {padding: 10, borderRadius: 20},
  marBot10: {
    marginBottom: 10,
  },
});
